export default __webpack_public_path__ + "static/media/Opel.095adc26.png";